/* One page lock for menu, cart and search, including their hand-offs. */
(() => {
  if (window.GlowOverlay) return;
  const owners = new Map();
  let saved, previousTouch;
  const remember = (element, keys) => {
    const values = keys.map(key => [key,element.style.getPropertyValue(key),element.style.getPropertyPriority(key)]);
    return () => values.forEach(([key,value,priority]) => value ? element.style.setProperty(key,value,priority) : element.style.removeProperty(key));
  };
  const set = (element,key,value) => element.style.setProperty(key,value,'important');
  const lock = () => {
    const body = document.body, html = document.documentElement;
    saved = {x:window.scrollX,y:window.scrollY,
      body:remember(body,['position','top','left','right','width','overflow','overscroll-behavior']),
      html:remember(html,['overflow','overflow-x','overflow-y','height','max-height','overscroll-behavior']),
      regions:[document.getElementById('MainContent'),...document.querySelectorAll('.shopify-section-group-footer-group')].filter(Boolean).map(el=>[el,el.inert])};
    html.setAttribute('data-glow-overlay-lock','');
    set(html,'overflow','hidden');set(html,'overflow-x','hidden');set(html,'overflow-y','hidden');
    set(html,'height','100%');set(html,'max-height','100%');set(html,'overscroll-behavior','none');
    set(body,'position','fixed');set(body,'top',`${-saved.y}px`);set(body,'left',`${-saved.x}px`);
    set(body,'right','auto');set(body,'width','100%');set(body,'overflow','hidden');set(body,'overscroll-behavior','none');
    saved.regions.forEach(([el])=>{el.inert=true;});
  };
  const unlock = () => {
    if (!saved) return;
    const restore = saved;saved=null;previousTouch=null;
    restore.body();restore.html();restore.regions.forEach(([el,value])=>{el.inert=value;});
    document.documentElement.removeAttribute('data-glow-overlay-lock');
    const restoreBehavior=remember(document.documentElement,['scroll-behavior']);
    set(document.documentElement,'scroll-behavior','auto');window.scrollTo(restore.x,restore.y);restoreBehavior();
    document.dispatchEvent(new Event('glow:overlay-change'));
  };
  const release = key => { owners.delete(key);if(!owners.size)unlock(); };
  const acquire = (key,panel,close) => {
    if (!owners.size) lock();
    owners.set(key,{panel,close});
    // Install the new owner first, so closing an old panel cannot unlock it.
    [...owners].forEach(([other,entry])=>{if(other!==key)entry.close?.();});
    document.dispatchEvent(new Event('glow:overlay-change'));
  };
  const roots = () => [...owners.values()].map(entry=>entry.panel).concat([...document.querySelectorAll('dialog[open]')]);
  const canScroll = (target,delta) => {
    const root=roots().find(panel=>panel?.contains(target));
    if (!root) return false;
    for(let element=target?.nodeType===1?target:target?.parentElement;element;element=element.parentElement){
      const style=getComputedStyle(element);
      if(/auto|scroll/.test(style.overflowY) && element.scrollHeight>element.clientHeight+1){
        if(delta<0 && element.scrollTop>0)return true;
        if(delta>0 && element.scrollTop+element.clientHeight<element.scrollHeight-1)return true;
      }
      if(element===root)break;
    }
    return false;
  };
  document.addEventListener('touchstart',event=>{
    previousTouch=event.touches.length===1?{x:event.touches[0].clientX,y:event.touches[0].clientY}:null;
  },{capture:true,passive:true});
  document.addEventListener('touchmove',event=>{
    if(!owners.size)return;
    if(event.touches.length!==1){if(event.cancelable)event.preventDefault();return;}
    const point=event.touches[0],dx=point.clientX-(previousTouch?.x??point.clientX),dy=point.clientY-(previousTouch?.y??point.clientY);
    previousTouch={x:point.clientX,y:point.clientY};
    const inside=roots().some(panel=>panel?.contains(event.target));
    // Horizontal drawer dragging remains available. Vertical motion must have
    // somewhere inside the active panel to scroll, including at its boundaries.
    if(inside && Math.abs(dx)>Math.abs(dy)*1.15)return;
    if(!inside || !canScroll(event.target,-dy)){if(event.cancelable)event.preventDefault();}
  },{capture:true,passive:false});
  document.addEventListener('wheel',event=>{
    if(owners.size && !canScroll(event.target,event.deltaY) && event.cancelable)event.preventDefault();
  },{capture:true,passive:false});
  window.addEventListener('scroll',()=>{
    if(owners.size && (window.scrollY!==0 || window.scrollX!==0))window.scrollTo(0,0);
  },{passive:true});
  const viewport=()=>{
    document.documentElement.style.setProperty('--glow-overlay-height',`${window.visualViewport?.height||window.innerHeight}px`);
  };
  window.addEventListener('resize',viewport,{passive:true});
  window.visualViewport?.addEventListener('resize',viewport,{passive:true});
  window.addEventListener('pagehide',()=>{
    [...owners.values()].forEach(entry=>entry.close?.());owners.clear();unlock();
  });
  window.GlowOverlay={acquire,release,isLocked:()=>owners.size>0,position:()=>saved?{x:saved.x,y:saved.y}:{x:window.scrollX,y:window.scrollY}};
  viewport();
})();

/* The main drawer has one owner. Its panel lives outside the sticky header. */
(() => {
  let state;
  const focusable = 'a[href],button:not([disabled]),summary,[tabindex="0"]';
  const init = () => {
    const root = document.getElementById('Details-menu-drawer-container');
    const drawer = document.getElementById('menu-drawer');
    const header = root?.closest('.section-header');
    if (!root || !drawer || !header || root.dataset.glowShellReady) return;
    root.dataset.glowShellReady = 'true';
    const toggle = root.querySelector(':scope > summary');
    const backdrop = document.createElement('div');
    backdrop.className = 'glow-menu-backdrop';
    backdrop.setAttribute('aria-hidden', 'true');
    drawer.dataset.glowManaged = 'true';
    drawer.setAttribute('role', 'navigation');
    drawer.setAttribute('aria-label', 'Главно меню');
    drawer.inert = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.append(backdrop, drawer);
    let opened = false, frame = 0, restoreHeader;
    let gesture = null, settleTimer = 0, settleFrame = 0, suppressClickUntil = 0;
    const cleanDrag = () => {
      clearTimeout(settleTimer); cancelAnimationFrame(settleFrame);
      settleTimer = settleFrame = 0;
      gesture = null;
      drawer.removeAttribute('data-glow-dragging');
      drawer.removeAttribute('data-glow-settling');
      drawer.style.removeProperty('--glow-menu-drag-x');
      backdrop.removeAttribute('data-glow-dragging');
      backdrop.removeAttribute('data-glow-settling');
      backdrop.style.removeProperty('--glow-menu-drag-opacity');
    };
    const pinHeader = () => {
      const keys=['position','top','left','right','width','transform','transition','z-index'];
      const previous=keys.map(key=>[key,header.style.getPropertyValue(key),header.style.getPropertyPriority(key)]);
      restoreHeader=()=>previous.forEach(([key,value,priority])=>value?header.style.setProperty(key,value,priority):header.style.removeProperty(key));
      const set=(key,value)=>header.style.setProperty(key,value,'important');
      set('position','fixed');set('left','0');set('right','0');set('width','100%');set('transform','none');set('transition','none');set('z-index','1003');
    };
    const fit = () => {
      frame = 0;
      if (!opened) return;
      const viewport = window.visualViewport;
      const width = Math.min(document.documentElement.clientWidth, window.innerWidth, viewport?.width || window.innerWidth);
      const height = viewport?.height || window.innerHeight;
      const offset = viewport?.offsetTop || 0;
      header.style.setProperty('top',`${offset}px`,'important');
      const headerHeight = Math.ceil((header.querySelector('.header-wrapper') || header).getBoundingClientRect().height);
      const style = document.documentElement.style;
      style.setProperty('--glow-menu-viewport-top', `${offset}px`);
      style.setProperty('--glow-menu-top', `${offset + headerHeight}px`);
      style.setProperty('--glow-menu-height', `${Math.max(0, height - headerHeight)}px`);
      style.setProperty('--glow-menu-width', `${Math.floor(width * (window.matchMedia('(min-width:990px)').matches ? 1 : .9))}px`);
    };
    const scheduleFit = () => { if (opened && !frame) frame = requestAnimationFrame(fit); };
    const lock = () => { window.GlowOverlay.acquire('menu',drawer,()=>close({restoreFocus:false}));pinHeader(); };
    const unlock = () => { restoreHeader?.();restoreHeader=null;window.GlowOverlay.release('menu'); };
    const focusMenu = (element = toggle) => element?.focus({preventScroll:true});
    const close = ({restoreFocus = true} = {}) => {
      if (!opened) return;
      cleanDrag();
      opened = false;
      document.querySelectorAll('[data-glow-category-panel][open]').forEach(panel => panel.close('menu'));
      drawer.querySelectorAll('details').forEach(details => {
        details.open = false;
        details.classList.remove('menu-opening','is-closing','submenu-open');
        details.querySelector(':scope > summary')?.setAttribute('aria-expanded','false');
      });
      root.classList.remove('menu-opening','isitglow-menu-dragging','isitglow-menu-settling');
      root.open = false;
      toggle.setAttribute('aria-expanded','false');
      drawer.dataset.glowOpen = 'false';
      drawer.inert = true;
      drawer.setAttribute('aria-hidden','true');
      header.classList.remove('menu-open');
      delete document.body.dataset.glowMenuOpen;
      unlock();
      if (restoreFocus) focusMenu();
    };
    const open = () => {
      if (opened) return;
      cleanDrag();
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      opened = true;
      lock();
      document.body.dataset.glowMenuOpen = 'true';
      header.classList.add('menu-open');
      header.classList.remove('shopify-section-header-hidden');
      root.open = true;
      root.classList.add('menu-opening');
      toggle.setAttribute('aria-expanded','true');
      ['transition','transform','opacity','will-change'].forEach(key => drawer.style.removeProperty(key));
      drawer.inert = false;
      drawer.setAttribute('aria-hidden','false');
      drawer.dataset.glowOpen = 'true';
      drawer.scrollTop = 0;
      drawer.querySelector('.menu-drawer__navigation-container')?.scrollTo(0,0);
      fit();
      focusMenu(toggle);
    };
    state = {root, drawer, toggle, header, backdrop, open, close, focusMenu, isOpen:() => opened,
      suppressClick:() => Date.now() < suppressClickUntil};
    window.GlowNavigation = {open, close, focusMenu, isOpen:() => opened};
    const changedViewport = () => { if (opened) { header.classList.remove('shopify-section-header-hidden'); scheduleFit(); } };
    window.addEventListener('resize', changedViewport, {passive:true});
    window.visualViewport?.addEventListener('resize', changedViewport, {passive:true});
    window.visualViewport?.addEventListener('scroll', scheduleFit, {passive:true});
    new ResizeObserver(scheduleFit).observe(header.querySelector('.header-wrapper') || header);
    window.addEventListener('pagehide', () => close({restoreFocus:false}));
    window.addEventListener('pageshow', event => { if (event.persisted && opened) close({restoreFocus:false}); });
    const paintDrag = x => {
      drawer.style.setProperty('--glow-menu-drag-x', `${x}px`);
      backdrop.style.setProperty('--glow-menu-drag-opacity', String(Math.max(0, 1 + x / (gesture?.width || drawer.getBoundingClientRect().width))));
    };
    const settle = (dismiss, x, width) => {
      gesture = null;
      drawer.removeAttribute('data-glow-dragging');
      backdrop.removeAttribute('data-glow-dragging');
      drawer.setAttribute('data-glow-settling', '');
      backdrop.setAttribute('data-glow-settling', '');
      // Commit the finger position before interpolating to the chosen endpoint.
      drawer.getBoundingClientRect();
      settleFrame = requestAnimationFrame(() => {
        settleFrame = 0;
        if (!opened) return;
        paintDrag(dismiss ? -width - 14 : 0);
        settleTimer = window.setTimeout(() => {
          settleTimer = 0;
          if (dismiss) close(); else cleanDrag();
        }, window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 0 : dismiss ? 430 : 350);
      });
    };
    const startDrag = event => {
      if (!opened || event.isPrimary === false || (event.pointerType === 'mouse' && event.button !== 0) ||
          document.querySelector('[data-glow-category-panel][open]') || event.target.closest('[data-showroom-track],input,textarea,select')) return;
      const width = drawer.getBoundingClientRect().width;
      const current = parseFloat(drawer.style.getPropertyValue('--glow-menu-drag-x')) || 0;
      cleanDrag();
      gesture = {id:event.pointerId, startX:event.clientX-current, startY:event.clientY, lastX:event.clientX,
        time:performance.now(), velocity:0, width, x:current, horizontal:false};
    };
    const moveDrag = event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.startX, dy = event.clientY - gesture.startY;
      if (!gesture.horizontal) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 10) return;
        // Lock a horizontal gesture only. Native vertical scrolling stays free.
        if (Math.abs(dy) >= Math.abs(dx) / 1.2 || dx > 0) { cleanDrag(); return; }
        gesture.horizontal = true;
        if (event.pointerType !== 'touch') drawer.setPointerCapture?.(event.pointerId);
        drawer.setAttribute('data-glow-dragging', '');
        backdrop.setAttribute('data-glow-dragging', '');
      }
      if (event.cancelable) event.preventDefault();
      const now = performance.now(), elapsed = now - gesture.time;
      if (elapsed > 0) gesture.velocity = (event.clientX - gesture.lastX) / elapsed;
      gesture.lastX = event.clientX; gesture.time = now;
      gesture.x = Math.max(-gesture.width, Math.min(0, dx));
      paintDrag(gesture.x);
    };
    const endDrag = (event, cancelled = false) => {
      if (!gesture || event.pointerId !== gesture.id) return;
      if (!gesture.horizontal) { cleanDrag(); return; }
      const {x,width,time,velocity} = gesture;
      const speed = performance.now() - time > 100 ? 0 : velocity;
      const progress = Math.abs(x) / width;
      const dismiss = !cancelled && (progress >= .72 || (speed <= .18 && (progress >= .3 || (speed < -.45 && progress > .08))));
      if (event.cancelable) event.preventDefault();
      suppressClickUntil = Date.now() + 500;
      settle(dismiss,x,width);
    };
    const touchEvent = (event,touch) => ({
      pointerId:`touch-${touch.identifier}`,pointerType:'touch',isPrimary:true,
      clientX:touch.clientX,clientY:touch.clientY,target:event.target,
      cancelable:event.cancelable,preventDefault:()=>event.preventDefault()
    });
    drawer.addEventListener('touchstart',event => {
      if(event.touches.length!==1){cleanDrag();return;}
      startDrag(touchEvent(event,event.touches[0]));
    },{passive:true});
    drawer.addEventListener('touchmove',event => {
      if(!gesture)return;
      if(event.touches.length!==1){endDrag({pointerId:gesture.id,cancelable:false},true);return;}
      const touch=[...event.touches].find(point=>`touch-${point.identifier}`===gesture.id);
      if(touch)moveDrag(touchEvent(event,touch));
    },{passive:false});
    drawer.addEventListener('touchend',event => {
      if(!gesture)return;
      const touch=[...event.changedTouches].find(point=>`touch-${point.identifier}`===gesture.id);
      if(touch)endDrag(touchEvent(event,touch));
    },{passive:false});
    drawer.addEventListener('touchcancel',() => {
      if(gesture)endDrag({pointerId:gesture.id,cancelable:false},true);
    },{passive:true});
    drawer.addEventListener('pointerdown',event => {if(event.pointerType!=='touch')startDrag(event);},{passive:true});
    drawer.addEventListener('pointermove',event => {if(event.pointerType!=='touch')moveDrag(event);},{passive:false});
    drawer.addEventListener('pointerup',event => {if(event.pointerType!=='touch')endDrag(event);},{passive:false});
    drawer.addEventListener('pointercancel',event => {if(event.pointerType!=='touch')endDrag(event,true);},{passive:true});
    drawer.addEventListener('lostpointercapture',event => {if(event.pointerType!=='touch')endDrag(event,true);},{passive:true});
  };
  window.addEventListener('click', event => {
    if (!state) return;
    // This listener precedes category navigation, including synthetic touch taps.
    if (state.suppressClick() && state.drawer.contains(event.target)) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    if (event.target.closest('#Details-menu-drawer-container > summary') === state.toggle) {
      event.preventDefault(); event.stopImmediatePropagation();
      state.isOpen() ? state.close() : state.open();
      return;
    }
    if (!state.isOpen() || document.querySelector('[data-glow-category-panel][open]')) return;
    const nestedToggle = event.target.closest('#menu-drawer summary:not([data-glow-category-trigger])');
    if (nestedToggle) {
      event.preventDefault(); event.stopImmediatePropagation();
      const details = nestedToggle.parentElement;
      const opening = !details.open || details.classList.contains('is-closing');
      clearTimeout(details._glowCloseTimer);
      details.classList.remove('is-closing');
      nestedToggle.setAttribute('aria-expanded',String(opening));
      if(opening){
        details.open=true;
        details.classList.remove('menu-opening');
        details.querySelector(':scope > .menu-drawer__submenu')?.getBoundingClientRect();
        requestAnimationFrame(()=>{if(details.open&&!details.classList.contains('is-closing'))details.classList.add('menu-opening');});
      }else{
        details.classList.add('is-closing');details.classList.remove('menu-opening');
        details._glowCloseTimer=setTimeout(()=>{details.open=false;details.classList.remove('is-closing');},560);
      }
      return;
    }
    if (event.target === state.backdrop) { event.preventDefault(); event.stopImmediatePropagation(); state.close(); return; }
    // Cart/search acquire their lock before releasing this menu. Closing here
    // would briefly unlock and remeasure the underlying page during hand-off.
    if (event.target.closest('.header__heading-link')) state.close({restoreFocus:false});
    else if (event.target.closest('#menu-drawer a[href]')) state.close({restoreFocus:false});
  }, true);
  window.addEventListener('keydown', event => {
    if (!state?.isOpen() || document.querySelector('[data-glow-category-panel][open]')) return;
    if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); state.close(); return; }
    if (event.key !== 'Tab') return;
    const elements = [state.toggle, ...state.drawer.querySelectorAll(focusable)].filter(element => !element.closest('[inert]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    const index = elements.indexOf(document.activeElement);
    const next = (index + (event.shiftKey ? -1 : 1) + elements.length) % elements.length;
    event.preventDefault(); event.stopImmediatePropagation(); elements[next]?.focus({preventScroll:true});
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();

